import { render } from "./Home.vue?vue&type=template&id=28acaaaf&ts=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=28acaaaf&lang=css"

import exportComponent from "/Users/jqrgen/dev/oida/webclient/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__